export const REGION_INDEX_TO_PROVINCE_INDEX = [
    [0],
    [1],
    [2],
    [3],
    [4],
    [5],
    [6],
    [7],
    [8],
];
